import { connect } from "react-redux";
import Reports from "./reports";
import { reportDownload, openTimesheetReport, openLeaveReport, openEquipmentUsageReport, reportClearResponseMessage } from "../actions";

const mapStateToProps = ({ report, staff, sites, profile, featureFlags }) => ({
    staffList: staff.pagination?.results,
    siteList: sites.pagination?.results,
    responseMessage: report.responseMessage,
    role: profile.role,
    save: report.save,
    featureFlags: featureFlags,
});

const mapDispatchToProps = {
    onDownload: reportDownload,
    onOpenTimesheetReport: openTimesheetReport,
    onOpenLeaveReport: openLeaveReport,
    onOpenEquipmentUsageReport: openEquipmentUsageReport,
    onClearResponseMessage: reportClearResponseMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Reports);